<template>
  <div
    class="conversation-label -webhook"
    :class="{ '-active': active, '-pending': isPending, '-approved': isApproved, '-denied': isDenied }"
    @click="click"
  >
    <span ref="image" class="image"></span>
    <span class="title">{{ title }}</span>
    <span class="updated">{{ fancyTime }}</span>
    <span class="name">{{ name }}</span>
    <span class="status">{{ conversation.webhook_status | unslugify }}</span>
  </div>
</template>

<script>
import moment from "moment";
import _ from "underscore";

export default {
  props: {
    conversation: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    name() {
      return this.conversation.metadata.context.customer_name || "New user";
    },

    title() {
      return this.conversation.metadata.context.title || "Live chat";
    },

    fancyTime() {
      return moment(this.conversation.closed_at, "YYYY-MM-DD HH:mm:ss").fromNow();
    },

    isPending() {
      return this.conversation.webhook_status === "pending_approval";
    },

    isApproved() {
      return _.contains(["approved", "auto_approved"], this.conversation.webhook_status);
    },

    isDenied() {
      return this.conversation.webhook_status === "denied";
    }
  },

  mounted() {
    this.$refs.image.style.backgroundImage = `url(${this.conversation.metadata.context.image}`;
  },

  methods: {
    click() {
      this.$emit("select", this.conversation);
    }
  }
};
</script>
